"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var chevron_left_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_left"));
var chevron_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_right"));
var S = __importStar(require("./LftTabGroup.styles"));
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var use_mobile_hook_1 = require("../../utils/hooks/use-mobile.hook");
var LftTabGroup = function (_a) {
    var bgColor = _a.bgColor, children = _a.children, _b = _a.currentTabindex, currentTabindex = _b === void 0 ? 0 : _b, dataSection = _a.dataSection, dataTestId = _a.dataTestId, id = _a.id, lftChange = _a.lftChange;
    var _c = (0, react_1.useState)(currentTabindex), selectedTab = _c[0], setSelectedTab = _c[1];
    var _d = react_1.default.useState(false), displayStartScroll = _d[0], setDisplayStartScroll = _d[1];
    var _e = react_1.default.useState(false), displayEndScroll = _e[0], setDisplayEndScroll = _e[1];
    //Variavéis para controlar o movimento do scroll no celular
    var _f = (0, react_1.useState)(null), startX = _f[0], setStartX = _f[1];
    var _g = (0, react_1.useState)(0), scrollLeft = _g[0], setScrollLeft = _g[1];
    var dataElement = dataSection === null || dataSection === void 0 ? void 0 : dataSection.replace('section_', '');
    var tablet = (0, use_mobile_hook_1.useMobile)().tablet;
    var tabMenu = [];
    var tabMenuRef = (0, react_1.useRef)(null);
    var handleTouchStart = function (e) {
        setStartX(e.touches[0].clientX);
    };
    var handleTouchMove = function (e) {
        if (!startX)
            return;
        var currentX = e.touches[0].clientX;
        var diff = startX - currentX;
        tabMenuRef.current.scrollLeft = scrollLeft + diff;
    };
    var handleTouchEnd = function () {
        setStartX(null);
        setScrollLeft(tabMenuRef.current.scrollLeft);
    };
    var handleChange = function (index) {
        var currentIndex = index;
        setSelectedTab(currentIndex);
        var children = tabMenuRef.current.children;
        if (children && children[index]) {
            children[index].scrollIntoView({ behavior: 'smooth', block: "nearest", inline: "nearest" });
        }
        lftChange &&
            lftChange({
                currentIndex: currentIndex,
            });
    };
    var handleKeyDown = function (event) {
        var tabMenuChildren = Array.from(tabMenuRef.current.children);
        // Pega o atual elemento ativo
        var activeElement = document.activeElement;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            // Acho o index do elemento atual
            var currentIndex = tabMenuChildren.indexOf(activeElement);
            if (currentIndex !== -1) {
                var nextIndex = void 0;
                if (event.key === 'ArrowLeft') {
                    // Movo pra esquerda
                    nextIndex = (currentIndex - 1 + tabMenuChildren.length) % tabMenuChildren.length;
                }
                else {
                    // Movo pra direita
                    nextIndex = (currentIndex + 1) % tabMenuChildren.length;
                }
                // Pego o próximo elemento com foco dentro do container
                var nextElement = tabMenuChildren[nextIndex];
                // Seto o foco para o próximo elemento
                if (nextElement) {
                    nextElement.focus();
                }
            }
        }
        if (event.key === 'Escape') {
            activeElement.blur();
        }
    };
    var getScrollSize = function () {
        var containerSize = tabMenuRef.current['clientWidth'];
        var totalSize = 0;
        var children = Array.from(tabMenuRef.current.children);
        for (var i = 0; i < children.length; i += 1) {
            var tab = children[i];
            if (totalSize + tab['clientWidth'] > containerSize) {
                if (i === 0) {
                    totalSize = containerSize;
                }
                break;
            }
            totalSize += tab['clientWidth'];
        }
        return totalSize;
    };
    var scroll = function (scrollValue, direction) {
        var tabMenu = tabMenuRef.current;
        var maxScrollLeft = tabMenu.scrollWidth - tabMenu.clientWidth;
        // Ensure scrollValue is within valid bounds
        scrollValue = Math.max(0, Math.min(maxScrollLeft, scrollValue));
        // Animate the scroll
        tabMenu.scrollTo({
            left: scrollValue + (direction === 'left' ? -1 : 1),
            behavior: 'smooth', // Use 'auto' for instant scrolling
        });
    };
    var moveTabsScroll = function (delta, direction) {
        var scrollValue = null;
        scrollValue = tabMenuRef.current['scrollLeft'];
        scrollValue += delta * 1;
        scroll(scrollValue, direction);
    };
    var handleStartScrollClick = function () {
        moveTabsScroll(-1 * getScrollSize(), 'left');
    };
    var handleEndScrollClick = function () {
        moveTabsScroll(getScrollSize(), 'right');
    };
    (0, react_1.useEffect)(function () {
        setSelectedTab(currentTabindex);
    }, [currentTabindex]);
    (0, react_1.useEffect)(function () {
        var tabListChildren = Array.from(tabMenuRef.current.children);
        var length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' &&
            length > 0) {
            var firstTab = tabListChildren[0];
            var lastTab = tabListChildren[length - 1];
            var observerOptions = {
                root: tabMenuRef.current,
                threshold: 0.99,
            };
            var handleScrollButtonStart = function (entries) {
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            var firstObserver_1 = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver_1.observe(firstTab);
            var handleScrollButtonEnd = function (entries) {
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            var lastObserver_1 = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver_1.observe(lastTab);
            return function () {
                firstObserver_1.disconnect();
                lastObserver_1.disconnect();
            };
        }
        return;
    });
    react_1.Children.map(children, function (child, index) {
        if ((0, react_1.isValidElement)(child)) {
            tabMenu.push((0, jsx_runtime_1.jsx)(S.TabButtonStyled, __assign({ "aria-controls": "panel-" + index, "aria-selected": selectedTab === index ? true : false, bgColor: bgColor, className: selectedTab === index ? 'active' : '', "data-element": child.props.dataElement ? "option_" + child.props.dataElement : dataElement && "option_" + (index + 1) + "-" + dataElement, "data-info": child.props.dataInfo, id: "tab-" + index, role: "tab", tabIndex: index === selectedTab ? 0 : -1, onClick: function () { return handleChange(index); } }, { children: (0, jsx_runtime_1.jsx)("span", { children: child.props.title }, void 0) }), index));
        }
    });
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            dataSection = "section_" + dataSection;
    }
    return ((0, jsx_runtime_1.jsxs)(S.TabContainerHostStyled, __assign({ "data-testid": dataTestId ? dataTestId : id && id, id: id, bgColor: bgColor }, { children: [(0, jsx_runtime_1.jsxs)(S.TabContainerStyled, __assign({ bgColor: bgColor, "data-section": dataSection }, { children: [(0, jsx_runtime_1.jsx)(S.TabArrowWrapper, { children: displayStartScroll && (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { ariaLabel: 'Retroceder', bgColor: bgColor, icon: chevron_left_1.default, size: tablet ? 'sm' : 'lg', lftClick: handleStartScrollClick }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(S.TabGroupStyled, __assign({ onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, ref: tabMenuRef, role: "tablist", onKeyDown: handleKeyDown }, { children: tabMenu }), void 0), (0, jsx_runtime_1.jsx)(S.TabArrowWrapper, { children: displayEndScroll && (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { ariaLabel: 'Avan\u00E7ar', bgColor: bgColor, icon: chevron_right_1.default, size: tablet ? 'sm' : 'lg', lftClick: handleEndScrollClick }, void 0) }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(S.TabContentsStyled, __assign({ "aria-labelledby": 'tab-' + selectedTab.toString(), id: 'tab-' + selectedTab.toString(), role: "tabpanel" }, { children: children && children[selectedTab] }), void 0)] }), void 0));
};
exports.default = LftTabGroup;
